import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL, statusList } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { StudentsListingModel } from 'common/models/page-models/student/gridmodel/student-grid.data.model';
import { StudentsModel } from 'common/models/page-models/student/formmodel/student-data.model';
import { StudentsGridParams } from 'common/models/page-models/student/gridmodel/student-grid.meta.model';
import { environment } from 'src/environments/environment';
import { stateListDataService } from '../../custom-service/stateList-service.service';


@Injectable({
    providedIn: 'root'
})
export class StudentsGridDataService extends GridDataService<StudentsListingModel, StudentsModel> {
    constructor(http: SmApiService, protected override ss: SystemService, private stateListService: stateListDataService) {
        super(API_URL.studentTable, http, ss);
        this.stateListService.getStateList();
    }

    createInstance(): StudentsListingModel {
        return new StudentsListingModel();
    }

    override getGridParams(param): GridPostParams {
        return new StudentsGridParams();
    }

    getDeleteUrl() {
        return '';
    }

    override transformDataModel(data: any[], param: string): any[] {
        super.transformDataModel(data, param);

        // Combine first and last names
       
        data[param].forEach(item => {
            item.studentName = `${item.first_name} ${item.last_name}`;

            item.statusName = statusList.filter((status) => parseInt(status.value) === item.status)[0].name;
            // console.log(item.state_id)
            item.stateName =this.stateListService.getStateNameById(item.state_id);

        });


        // Sort by first_name in ascending order
        data[param].sort((a, b) => a.first_name.localeCompare(b.first_name));
        return data;
    }


    override getStatusUrl(): string {
        return '/studentdetail/statusUpdate';
    }

    override getStatusPayload(data): any {
        let payload;

        payload = { id: data.id, status: data.status === 1 ? 2 : 1 };

        return payload;
    }

    override getDeletePayload(data) {
        let payload = {
            multi_check: [data.id]
        }
        return payload;
    }

    override getExcelUploadUrl() {
        return environment.apiUrl + API_URL.downloadStudent;
    }

}
